let _ = t => t,
  _t,
  _t2;
import _styled2 from "styled-components";
import _styled from "styled-components";
import { PureComponent } from 'react';
import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import UIBox from 'UIComponents/layout/UIBox';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const tlmSidebarDynamicWidthStyles = css(["min-width:260px;max-width:376px;width:21vw;@media (min-width:1920px){max-width:420px;}"]);
export const StyledUIBox = styled(UIBox).withConfig({
  displayName: "ThreadListMemberSidebarFrame__StyledUIBox",
  componentId: "sc-160b2k8-0"
})(["display:flex;height:100%;background-color:", ";flex-direction:column;", ""], OLAF, tlmSidebarDynamicWidthStyles);
export default class ThreadListMemberSidebarFrame extends PureComponent {
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsx(StyledUIBox, {
      grow: 1,
      basis: "100%",
      className: "selenium--inbox-conversation-selector",
      shrink: 0,
      children: /*#__PURE__*/_jsx(_StyledUIBox, {
        className: "chat-sidebar display-flex flex-column selenium-test-marker-thread-list width-100"
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        ,

        grow: 1,
        shrink: 0,
        basis: "100%",
        children: /*#__PURE__*/_jsx(_StyledUIBox2, {
          grow: 1,
          shrink: 0,
          basis: "100%",
          children: children
        })
      })
    });
  }
}
ThreadListMemberSidebarFrame.displayName = 'ThreadListMemberSidebarFrame';
var _StyledUIBox = _styled(UIBox)(_t || (_t = _`
            background-color: ${0};
          `), OLAF);
var _StyledUIBox2 = _styled2(UIBox)(_t2 || (_t2 = _`
              display: flex;
              flex-direction: column;
              overflow-x: hidden;
              border-right: solid 1px ${0};
            `), GREAT_WHITE);